import { render, staticRenderFns } from "./ReservationMessages.vue?vue&type=template&id=59850582&scoped=true&"
import script from "./ReservationMessages.vue?vue&type=script&lang=js&"
export * from "./ReservationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59850582",
  null
  
)

export default component.exports